export const PRINT_DOUGH_URI = '/print-dough'
export const PRINT_LEVAIN_URI = '/print-levain'